export default __webpack_public_path__ + "static/media/aplicacoes-react-native.4cc0dbd5.png";